<template>
    <div class="pt-[8px]">
        <div class="text-sm font-semibold font-oceanside">
            {{$t('CHARACTER_LIST')}}
        </div>

        <div class="w-[80%]">
            <div v-for="(line, lineIndex) in characters" :key="lineIndex"
                class="flex flex-wrap gap-[2px]"
            >
                <span v-for="(ch, chIndex) in line" :key="chIndex"
                    class="text-[14px] font-oceanside"
                >
                    {{ch}}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            characters: Array,
        },
    };
</script>
